import { z } from 'zod';

export type ReportReviewTypeOptions = 'LANGUAGE' | 'FALSEHOOD' | 'OTHER';

export type ReportReviewModalPropsMicrocopy = {
  title: string;
  placeholder: string;
  descriptionTitle: string;
  description: string;
  close: string;
  primaryCta: string;
  secondaryCta: string;
  triggerLabel: string;
  reportType: {
    title: string;
    options: Array<{
      label: string;
      value: ReportReviewTypeOptions;
    }>;
  };
  support: {
    title: string;
    description: string;
  };
  confirmationMessage: {
    title: string;
    subtitle: string;
  };
  serverMessage?: {
    title: string;
    description: string;
    dismiss: string;
    cta?: string;
  };
};

export const MAX_REPORT_REVIEW_CHARS = 3000;

export const reportReviewFormSchema = z.object({
  reportReview: z.string().min(1).max(MAX_REPORT_REVIEW_CHARS),
  reportType: z.string().min(1),
});

export type ReportReviewModalData = z.infer<typeof reportReviewFormSchema>;

export type ReportReviewModalPropsActions = {
  onSubmitReport: (
    reviewId: string,
    report: ReportReviewModalData
  ) => Promise<void>;
};

export type ReportReviewModalProps = ReportReviewModalPropsActions & {
  microcopy: ReportReviewModalPropsMicrocopy;
  reviewId: string;
  className?: string;
};
